<template>
    <div class="process-indicator flex-row justify-between">
        <span class="label">{{ label }}</span>
        <div class="progress flex-col">
            <div class="tag flex-col" :style="{ marginLeft: `${value}%` }">
                <span class="value">{{ value }}</span>
            </div>
            <div class="container"><div class="bar" :style="{ width: `${value}%` }"></div></div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ProgressIndicator",
    props: {
        label: {
            type: String,
            required: true,
        },
        value: {
            type: [String, Number],
            required: true,
        },
    },
};
</script>

<style lang="scss" scoped>
@import "@s/common.scss";

.process-indicator {
    margin-bottom: 0.16rem;

    .label {
        width: 1.92rem;
        overflow-wrap: break-word;
        color: rgba(51, 51, 51, 1);
        font-size: 0.293rem;
        font-weight: bold;
        text-align: left;
        line-height: 0.507rem;
        margin-top: 0.347rem;
    }

    .progress {
        margin-bottom: 0.16rem;

        .tag {
            background: url(../../../assets/ceping113/progress_indicator_tag.png) 0 0 no-repeat;
            background-size: 0.774rem 0.534rem;
            width: 0.774rem;
            height: 0.534rem;
            transform: translateX(-50%);

            .value {
                overflow-wrap: break-word;
                color: rgba(255, 255, 255, 1);
                font-size: 0.24rem;
                font-weight: bold;
                text-align: center;
                white-space: nowrap;
                line-height: 0.45rem;
            }
        }

        .container {
            width: 5.68rem;
            height: 0.107rem;
            margin-top: 0.08rem;
            background: linear-gradient( 90deg, rgba(238,238,238,0) 0%, #E3E4E3 26%, #E3E4E3 77%, rgba(216,216,216,0) 100%);
            border-radius: 0.05rem;

            .bar {
                height: 0.1rem;
                background: linear-gradient( 90deg, rgba(25,201,75,0) 0%, #19C94B 100%);
                border-radius: 0.05rem;
            }
        }
    }
}
</style>